import { FileDownload } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

type PropsType = {
  onCustomPDFExport: () => void;
  isLoading?: boolean;
};

export const ReportDataExportCustom = (props: PropsType) => {
  const { onCustomPDFExport, isLoading } = props;

  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id={'report-export-button'}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup={'true'}
        aria-expanded={open ? 'true' : undefined}
        disabled={isLoading}
        onClick={handleClick}
      >
        <FileDownload />
      </IconButton>
      <Menu
        id={'report-export-menu'}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'report-export-button',
        }}
      >
        <MenuItem
          key={`export-PDF-custom`}
          onClick={() => {
            onCustomPDFExport();
          }}
        >
          {t('laExpPDF')}
        </MenuItem>
      </Menu>
    </>
  );
};
